import React from "react";
import ReportStatCard from "./ReportStatCard";

const PaymentReportCards = ({ data }) => {
  return (
    <>
      <ReportStatCard
        title="Gross Collected"
        value={`₹${data.grossCollected.toLocaleString("en-IN")}`}
        subtitle="Total payment received"
        icon="fas fa-money-bill-wave"
        iconClass="bg-success"
      />

      <ReportStatCard
        title="Gateway Fees"
        value={`₹${data.gatewayFees.toLocaleString("en-IN")}`}
        subtitle="Razorpay fees"
        icon="fas fa-credit-card"
        iconClass="bg-warning"
        valueClass="text-dark"
      />

      <ReportStatCard
        title="GST on Fees"
        value={`₹${data.gstOnFees.toLocaleString("en-IN")}`}
        subtitle="GST on gateway charges"
        icon="fas fa-percent"
        iconClass="bg-info"
      />

      <ReportStatCard
        title="Refunds"
        value={`₹${data.refunds.toLocaleString("en-IN")}`}
        subtitle="Total refunded amount"
        icon="fas fa-undo"
        iconClass="bg-danger"
      />

      <ReportStatCard
        title="Net Settled"
        value={`₹${data.netSettled.toLocaleString("en-IN")}`}
        subtitle="Amount settled"
        icon="fas fa-wallet"
        iconClass="bg-primary"
      />

      <ReportStatCard
        title="Pending Settlement"
        value={`₹${data.pendingSettlement.toLocaleString("en-IN")}`}
        subtitle="Awaiting settlement"
        icon="fas fa-hourglass-half"
        iconClass="bg-secondary"
      />

      <ReportStatCard
        title="Success Rate"
        value={`${data.successRate}%`}
        subtitle="Successful payments"
        icon="fas fa-check-circle"
        iconClass="bg-success"
      />
    </>
  );
};

export default PaymentReportCards;